export default __webpack_public_path__ + "static/media/app-logo.c2ce8106.svg";